import { z } from "zod";

import { planEntitlementsSchema } from "../entitlements";
import { normalizePlan } from "./plan";

/**
 * Ciclo de cobrança do plano. Era `enum PLAN_CYCLE` em
 * `apps/web/src/services/plans/types.ts`; o tipo tem o mesmo nome do objeto
 * para os importadores do web que o usam como tipo seguirem intactos.
 */
export const PLAN_CYCLE = { ANNUAL: "ANNUAL", MONTHLY: "MONTHLY" } as const;
export type PLAN_CYCLE = (typeof PLAN_CYCLE)[keyof typeof PLAN_CYCLE];

/** Decimal do Postgres chega como string; número também é aceito. */
const decimalSchema = z.union([z.number(), z.string()]).nullable().optional();

/** O plano como `GET /plan` devolve — nulável onde a coluna é (`Plan.entity.ts`). */
export const rawPlanSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  unitValue: decimalSchema,
  pricingModel: z.enum(["PER_UNIT", "BASE_PLUS_ADDITIONAL"]),
  baseValue: decimalSchema,
  additionalUnitValue: decimalSchema,
  trialPeriodDays: z.number().nullable(),
  isPrivate: z.boolean(),
  signable: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  minQuantity: z.number().nullable(),
  maxQuantity: z.number().nullable(),
  popular: z.boolean(),
  cycle: z.nativeEnum(PLAN_CYCLE).nullable(),
  priceDescription: z.string().nullable(),
  discount: z.number().nullable(),
  unitValueWithCoupon: decimalSchema,
  couponCode: z.string().nullable().optional(),
  priceDescriptionWithCoupon: z.string().nullable().optional(),
  priceOnRequest: z.boolean(),
  priceOnRequestLabel: z.string().nullable(),
  contactCtaLabel: z.string().nullable(),
  entitlements: planEntitlementsSchema.nullable().optional(),
});
export type RawPlan = z.infer<typeof rawPlanSchema>;

export const planSchema = rawPlanSchema.transform(normalizePlan);
export type Plan = z.output<typeof planSchema>;

/** Resposta de `GET /plan`. O SDK não importa zod: a lista também mora aqui. */
export const planListSchema = z.array(planSchema);
